import { forwardRef, memo } from 'react';
import SvgIcon, { type SvgIconProps } from '@material-ui/core/SvgIcon';

export const Prompt = memo(
  forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 115 110"
        data-fill-none
      >
        <mask
          id="mask0_1529_12710"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="115"
          height="110"
        >
          <rect
            width="115"
            height="110"
            rx="8"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask0_1529_12710)">
          <rect
            x="-12"
            y="-2"
            width="138"
            height="112"
            rx="4.45161"
            fill="#D0F4FF"
          />
          <rect
            x="15.6188"
            y="60.2482"
            width="38.8276"
            height="17.083"
            rx="1.16384"
            fill="white"
            stroke="#1E1E1E"
            strokeWidth="0.778707"
          />
          <g clipPath="url(#clip0_1529_12710)">
            <path
              d="M27.2674 68.8132C27.2674 70.7632 25.8474 72.3794 23.9912 72.6724V69.9425H24.8959L25.0681 68.8132H23.9912V68.0804C23.9912 67.7714 24.1416 67.4703 24.624 67.4703H25.1136V66.5089C25.1136 66.5089 24.6692 66.4326 24.2443 66.4326C23.3574 66.4326 22.7777 66.9734 22.7777 67.9525V68.8132H21.7918V69.9425H22.7777V72.6724C20.9215 72.3794 19.5015 70.7632 19.5015 68.8132C19.5015 66.6557 21.24 64.9065 23.3844 64.9065C25.5289 64.9065 27.2674 66.6557 27.2674 68.8132Z"
              fill="#1877F2"
            />
            <path
              d="M24.8956 69.9124L25.0678 68.79H23.9908V68.0616C23.9908 67.7546 24.1413 67.4552 24.6236 67.4552H25.1133V66.4997C25.1133 66.4997 24.6689 66.4238 24.2441 66.4238C23.3571 66.4238 22.7774 66.9614 22.7774 67.9345V68.79H21.7915V69.9124H22.7774V72.6258C22.9751 72.6568 23.1777 72.673 23.3841 72.673C23.5905 72.673 23.7931 72.6568 23.9908 72.6258V69.9124H24.8956Z"
              fill="white"
            />
          </g>
          <rect
            x="30.3735"
            y="64.9062"
            width="15.9202"
            height="1.55319"
            rx="0.388297"
            fill="#1E1E1E"
          />
          <rect
            x="30.3735"
            y="68.0127"
            width="20.5798"
            height="1.55319"
            rx="0.388297"
            fill="#1E1E1E"
          />
          <rect
            x="30.3735"
            y="71.1191"
            width="20.5798"
            height="1.55319"
            rx="0.388297"
            fill="#1E1E1E"
          />
          <rect
            x="9.38935"
            y="25.9851"
            width="38.8276"
            height="17.083"
            rx="1.16384"
            fill="white"
            stroke="#1E1E1E"
            strokeWidth="0.778707"
          />
          <g clipPath="url(#clip1_1529_12710)">
            <path
              d="M17.1545 31.3439C18.1912 31.3439 18.3142 31.3478 18.7238 31.3666C19.7761 31.4145 20.2676 31.9138 20.3155 32.9583C20.3343 33.3676 20.3379 33.4906 20.3379 34.5273C20.3379 35.5644 20.334 35.6871 20.3155 36.0964C20.2673 37.1399 19.7771 37.6402 18.7238 37.6881C18.3142 37.7068 18.1919 37.7107 17.1545 37.7107C16.1177 37.7107 15.9947 37.7068 15.5854 37.6881C14.5305 37.6399 14.0416 37.1383 13.9937 36.0961C13.9749 35.6867 13.9711 35.5641 13.9711 34.527C13.9711 33.4903 13.9753 33.3676 13.9937 32.958C14.0419 31.9138 14.5322 31.4142 15.5854 31.3663C15.9951 31.3478 16.1177 31.3439 17.1545 31.3439ZM17.1545 30.644C16.0999 30.644 15.9679 30.6486 15.5537 30.6673C14.1435 30.7321 13.3598 31.5145 13.2951 32.9259C13.276 33.3404 13.2715 33.4725 13.2715 34.527C13.2715 35.5816 13.276 35.7139 13.2948 36.1281C13.3595 37.5383 14.1419 38.322 15.5534 38.3867C15.9679 38.4055 16.0999 38.41 17.1545 38.41C18.209 38.41 18.3414 38.4055 18.7555 38.3867C20.1644 38.322 20.9501 37.5396 21.0138 36.1281C21.0329 35.7139 21.0374 35.5816 21.0374 34.527C21.0374 33.4725 21.0329 33.3404 21.0141 32.9263C20.9507 31.5174 20.1673 30.7324 18.7559 30.6677C18.3414 30.6486 18.209 30.644 17.1545 30.644V30.644ZM17.1545 32.5331C16.0533 32.5331 15.1606 33.4259 15.1606 34.527C15.1606 35.6282 16.0533 36.5212 17.1545 36.5212C18.2556 36.5212 19.1484 35.6285 19.1484 34.527C19.1484 33.4259 18.2556 32.5331 17.1545 32.5331ZM17.1545 35.8213C16.4397 35.8213 15.8601 35.2421 15.8601 34.527C15.8601 33.8122 16.4397 33.2327 17.1545 33.2327C17.8692 33.2327 18.4488 33.8122 18.4488 34.527C18.4488 35.2421 17.8692 35.8213 17.1545 35.8213ZM19.2273 31.9885C18.9697 31.9885 18.761 32.1972 18.761 32.4545C18.761 32.7117 18.9697 32.9204 19.2273 32.9204C19.4846 32.9204 19.693 32.7117 19.693 32.4545C19.693 32.1972 19.4846 31.9885 19.2273 31.9885Z"
              fill="url(#paint0_linear_1529_12710)"
            />
          </g>
          <rect
            x="24.144"
            y="32.1973"
            width="11.6489"
            height="1.55319"
            rx="0.388297"
            fill="#1E1E1E"
          />
          <rect
            x="24.144"
            y="35.3037"
            width="17.8617"
            height="1.55319"
            rx="0.388297"
            fill="#1E1E1E"
          />
          <rect
            x="31.7121"
            y="38.9638"
            width="38.8276"
            height="17.083"
            rx="1.16384"
            fill="white"
            stroke="#1E1E1E"
            strokeWidth="0.778707"
          />
          <path
            d="M37.5612 50.903H36.0942V46.2924H37.5612V50.903ZM40.6069 47.6474C40.4356 47.6474 40.2713 47.7147 40.1502 47.8345C40.029 47.9543 39.961 48.1167 39.961 48.2861V50.903H38.4185V46.2924H39.961V46.767C40.3225 46.4643 40.7793 46.2955 41.2529 46.2894C42.2098 46.2894 42.8739 46.9908 42.8739 48.3219V50.903H41.2529V48.2861C41.2533 48.202 41.2369 48.1186 41.2046 48.0408C41.1723 47.963 41.1248 47.8922 41.0648 47.8326C41.0048 47.7729 40.9334 47.7256 40.8548 47.6933C40.7763 47.6611 40.692 47.6444 40.6069 47.6444V47.6474ZM37.5884 44.8538C37.5884 45.0014 37.5441 45.1457 37.4612 45.2684C37.3783 45.3911 37.2604 45.4867 37.1225 45.5432C36.9846 45.5997 36.8329 45.6144 36.6865 45.5856C36.5401 45.5568 36.4057 45.4858 36.3001 45.3814C36.1946 45.2771 36.1227 45.1441 36.0936 44.9994C36.0645 44.8546 36.0794 44.7046 36.1365 44.5683C36.1937 44.4319 36.2904 44.3154 36.4145 44.2334C36.5386 44.1514 36.6845 44.1077 36.8337 44.1077C37.0328 44.1092 37.2232 44.1885 37.3635 44.3283C37.5037 44.4681 37.5824 44.657 37.5823 44.8538H37.5884Z"
            fill="#0A66C2"
            stroke="#0A66C2"
            strokeWidth="0.0724799"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="46.4663"
            y="43.6223"
            width="15.9202"
            height="1.55319"
            rx="0.388297"
            fill="#1E1E1E"
          />
          <rect
            x="46.4663"
            y="46.7288"
            width="9.70743"
            height="1.55319"
            rx="0.388297"
            fill="#1E1E1E"
          />
          <rect
            x="46.4663"
            y="49.8352"
            width="12.8138"
            height="1.55319"
            rx="0.388297"
            fill="#1E1E1E"
          />
          <g clipPath="url(#clip2_1529_12710)">
            <path
              d="M70.8511 64.1387H98.9527C98.9527 64.1387 101.295 64.1387 101.295 66.4805V75.8477C101.295 75.8477 101.295 78.1895 98.9527 78.1895H70.8511C70.8511 78.1895 68.5093 78.1895 68.5093 75.8477V66.4805C68.5093 66.4805 68.5093 64.1387 70.8511 64.1387Z"
              fill="#F0F0F0"
              stroke="black"
              strokeWidth="0.925633"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M73.1929 68.8225H75.5347"
              stroke="black"
              strokeWidth="0.925633"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M73.1929 73.5059H75.5347"
              stroke="black"
              strokeWidth="0.925633"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M80.2183 68.8225H82.5601"
              stroke="black"
              strokeWidth="0.925633"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M80.2183 73.5059H89.5855"
              stroke="black"
              strokeWidth="0.925633"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M87.2437 68.8225H89.5855"
              stroke="black"
              strokeWidth="0.925633"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M94.269 68.8225H96.6108"
              stroke="black"
              strokeWidth="0.925633"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M94.269 73.5059H96.6108"
              stroke="black"
              strokeWidth="0.925633"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M69.7017 75.3219C69.7002 74.7132 69.1916 74.2073 68.5322 74.1583C67.9235 74.1599 67.4176 74.6684 67.3686 75.3279L67.3911 84.0517C67.3937 85.0661 67.802 86.0795 68.5648 86.8383C69.3276 87.5972 70.343 88.0003 71.3574 87.9977L73.5891 87.992C75.1107 87.9881 76.5796 87.2235 77.4386 85.9533L80.2174 81.7363C80.5206 81.3298 80.5193 80.8226 80.214 80.4176C79.8575 79.8606 78.9948 79.7107 78.4887 80.1177L76.6159 81.5934L76.5965 74.0869C76.5949 73.4782 76.0864 72.9723 75.4269 72.9233C74.8183 72.9248 74.3124 73.4334 74.2634 74.0928L74.3114 73.0276C74.3098 72.419 73.8013 71.9131 73.1418 71.864C72.5331 71.8656 72.0273 72.3741 71.9782 73.0336L71.9811 74.1494C71.9795 73.5408 71.471 73.0349 70.8115 72.9859C70.2029 72.9874 69.697 73.496 69.648 74.1554L69.7017 75.3219Z"
              fill="#F8ECDF"
              stroke="black"
              strokeWidth="0.778707"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M74.2642 74.0901L74.2759 78.6549"
              stroke="black"
              strokeWidth="0.778707"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M71.981 74.1494L72.0436 78.7648"
              stroke="black"
              strokeWidth="0.778707"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M69.7105 78.7712L69.7017 75.3223"
              stroke="black"
              strokeWidth="0.778707"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M96.2529 73.8531C96.2544 73.2445 96.7629 72.7386 97.4224 72.6896C98.0311 72.6911 98.537 73.1996 98.586 73.8591L98.5635 82.583C98.5609 83.5974 98.1525 84.6107 97.3898 85.3696C96.627 86.1284 95.6116 86.5316 94.5972 86.529L92.3655 86.5232C90.8439 86.5193 89.375 85.7547 88.516 84.4845L85.7372 80.2676C85.434 79.861 85.4353 79.3538 85.7406 78.9489C86.0971 78.3918 86.9597 78.2419 87.4659 78.649L89.3387 80.1247L89.3581 72.6181C89.3597 72.0095 89.8682 71.5036 90.5277 71.4545C91.1363 71.4561 91.6422 71.9646 91.6912 72.6241L91.6432 71.5588C91.6448 70.9502 92.1533 70.4443 92.8128 70.3953C93.4214 70.3969 93.9273 70.9054 93.9764 71.5648L93.9735 72.6807C93.9751 72.0721 94.4836 71.5662 95.1431 71.5171C95.7517 71.5187 96.2576 72.0272 96.3066 72.6867L96.2529 73.8531Z"
              fill="#F8ECDF"
              stroke="black"
              strokeWidth="0.778707"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M91.6904 72.6216L91.6787 77.1864"
              stroke="black"
              strokeWidth="0.778707"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M93.9736 72.6807L93.911 77.2961"
              stroke="black"
              strokeWidth="0.778707"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M96.2441 77.3022L96.2529 73.8533"
              stroke="black"
              strokeWidth="0.778707"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <path
            d="M97.2438 36.7017V38.8067C97.2438 39.9123 96.3134 40.3573 94.9178 40.3573C93.5222 40.3573 92.5918 39.9123 92.5918 38.8067V36.7017"
            fill="#E3E3E3"
          />
          <path
            d="M97.2438 36.7017V38.8067C97.2438 39.9123 96.3134 40.3573 94.9178 40.3573C93.5222 40.3573 92.5918 39.9123 92.5918 38.8067V36.7017"
            stroke="#191919"
            strokeWidth="0.778707"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M96.8557 36.8686C97.7843 36.5005 98.5786 35.858 99.1327 35.0268C99.6868 34.1957 99.9743 33.2154 99.957 32.2166C99.9331 30.8875 99.3945 29.6195 98.4545 28.6795C97.5145 27.7395 96.2465 27.2009 94.9173 27.177C93.5882 27.2007 92.32 27.7393 91.38 28.6793C90.44 29.6193 89.9014 30.8874 89.8777 32.2166C89.8602 33.2154 90.1476 34.1958 90.7017 35.027C91.2559 35.8582 92.0503 36.5006 92.979 36.8686H96.8557Z"
            fill="#FFEF5E"
          />
          <path
            d="M94.9173 29.6906C96.0378 29.7111 97.1208 30.0981 98.0007 30.7923C98.8805 31.4864 99.5088 32.4497 99.7895 33.5347C99.9049 33.105 99.9613 32.6616 99.9569 32.2166C99.9331 30.8875 99.3944 29.6195 98.4544 28.6795C97.5145 27.7395 96.2464 27.2009 94.9173 27.177C93.5881 27.2007 92.32 27.7393 91.38 28.6793C90.4399 29.6193 89.9014 30.8874 89.8777 32.2166C89.8733 32.6616 89.9296 33.105 90.0451 33.5347C90.3258 32.4497 90.9541 31.4864 91.8339 30.7923C92.7138 30.0981 93.7968 29.7111 94.9173 29.6906Z"
            fill="#FFF9BF"
          />
          <path
            d="M96.8557 36.8686C97.7843 36.5005 98.5786 35.858 99.1327 35.0268C99.6868 34.1957 99.9743 33.2154 99.957 32.2166C99.9331 30.8875 99.3945 29.6195 98.4545 28.6795C97.5145 27.7395 96.2465 27.2009 94.9173 27.177C93.5882 27.2007 92.32 27.7393 91.38 28.6793C90.44 29.6193 89.9014 30.8874 89.8777 32.2166C89.8602 33.2154 90.1476 34.1958 90.7017 35.027C91.2559 35.8582 92.0503 36.5006 92.979 36.8686H96.8557Z"
            stroke="#191919"
            strokeWidth="0.778707"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M94.9175 40.3574V41.5204"
            stroke="#191919"
            strokeWidth="0.778707"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M94.9174 36.6359V33.3795L93.3667 31.8289"
            stroke="#191919"
            strokeWidth="0.778707"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M92.5918 38.4192H97.2438"
            stroke="#191919"
            strokeWidth="0.778707"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M94.9175 23.688V25.2386"
            stroke="#191919"
            strokeWidth="0.778707"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M86.3887 31.4412H88.1649"
            stroke="#191919"
            strokeWidth="0.778707"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M88.3271 25.6262L89.8778 27.1769"
            stroke="#191919"
            strokeWidth="0.778707"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M103.446 31.4412H101.67"
            stroke="#191919"
            strokeWidth="0.778707"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M101.508 25.6262L99.957 27.1769"
            stroke="#191919"
            strokeWidth="0.778707"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M94.9175 33.3795L96.4681 31.8289"
            stroke="#191919"
            strokeWidth="0.778707"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_1529_12710"
            x1="18.7724"
            y1="30.644"
            x2="16.0314"
            y2="37.9341"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#5E5CCB" />
            <stop
              offset="0.18214"
              stopColor="#8D40B7"
            />
            <stop
              offset="0.431696"
              stopColor="#DA2E7C"
            />
            <stop
              offset="0.753527"
              stopColor="#F15544"
            />
            <stop
              offset="1"
              stopColor="#FECA66"
            />
          </linearGradient>
          <clipPath id="clip0_1529_12710">
            <rect
              width="7.76595"
              height="7.76595"
              fill="white"
              transform="translate(19.501 64.9062)"
            />
          </clipPath>
          <clipPath id="clip1_1529_12710">
            <rect
              width="7.76595"
              height="7.76595"
              fill="white"
              transform="translate(13.2715 30.644)"
            />
          </clipPath>
          <clipPath id="clip2_1529_12710">
            <rect
              width="41.345"
              height="32.7057"
              fill="white"
              transform="translate(64.5479 59.8589)"
            />
          </clipPath>
        </defs>
      </SvgIcon>
    );
  })
);
Prompt.displayName = 'Prompt';
